import VisitorContext from './VisitorContext.jsx'
import { useContext, useRef, useState, useEffect } from 'react'
import Visitor from './Visitor.jsx'

const VisitorList = () => {
    const { visitors, search } = useContext(VisitorContext)
    const ulRef = useRef(null);
    const [atTop, setAtTop] = useState(true);
    const [atBottom, setAtBottom] = useState(false);

    const filteredVisitors = visitors.filter(
        (visitor) => visitor.visitor_first_name.toLowerCase().includes(search.toLowerCase())
    );

    const checkScroll = () => {
        const el = ulRef.current;
        if (!el) return;
        setAtTop(el.scrollTop < 2);
        setAtBottom(el.scrollHeight - el.scrollTop - el.clientHeight < 2);
    };

    // Re-check whenever the list grows or shrinks (scroll height changes).
    useEffect(() => {
        checkScroll();
    }, [filteredVisitors.length]);

    const scrollClass = [
        atTop    ? 'scroll-at-top'    : '',
        atBottom ? 'scroll-at-bottom' : '',
    ].filter(Boolean).join(' ');

    return (
        <div>
            {filteredVisitors.length > 0 ? (
                <ul
                    ref={ulRef}
                    onScroll={checkScroll}
                    className={scrollClass}
                >
                    {filteredVisitors.map((visitorItem) => (
                        <Visitor key={visitorItem.id} visitorItem={visitorItem} />
                    ))}
                </ul>
            ) : (
                <span>People for the planned visit.</span>
            )}
        </div>
    )
}

export default VisitorList
